import type { ShouldHideStandaloneVideoArgs } from './shouldHideStandaloneVideo.types';

/**
 * Whether a Brannan standalone video header drops its video and renders title + nav only.
 * Compact view (classic navigation, non-welcome page) hides it for the hamburger nav, where
 * the strip has nothing to sit behind, and for couples who opted to keep the video on the
 * welcome page only. Absent opt-in keeps the compact video strip.
 */
export const shouldHideStandaloneVideo = ({ isCompactView, navBarVariant, showVideoOnlyOnWelcomePage }: ShouldHideStandaloneVideoArgs): boolean =>
  isCompactView && (navBarVariant === 'menu' || showVideoOnlyOnWelcomePage === true);
